export default __webpack_public_path__ + "static/media/corleone.8291accf.png";